import { createContext } from "react";

import { INIT_STATE } from "../redux/settings/reducer";
import { SETTINGS_INIT_STATE } from "./settings/reducer";
import { USER_INIT_STATE } from "./user_auth/reducer";

const Context = createContext({
  locale: INIT_STATE,
  currentUser: USER_INIT_STATE,
  settings: SETTINGS_INIT_STATE,
  singleSeller: null,
});

export default Context;
